import type { LevelAssessmentView, LevelReportView } from '@en3/shared';
import { api } from './client';
import { toQuery } from './content.api';

/**
 * 水平评估接口（阶段 6）。
 *
 * 注意"评估"与"报告"是两个动作：
 * - `assess` 是**写操作**（会落一条 `level_assessments`），且后端有 5 分钟复用窗口；
 * - `report` 是读操作，永远返回最新结论 + 历史 + 实时特征。
 *
 * 页面上的正确用法是：进页面只调 `report`；用户点"重新评估"才调 `assess`。
 * 否则每次刷新都会写一条评估记录，趋势图会变成噪声。
 */

export const levelApi = {
  assess: (input: { articleId?: string; force?: boolean } = {}) =>
    api.post<{ assessment: LevelAssessmentView }>('/api/level/assess', input),

  report: (params: { history?: boolean; limit?: number } = {}) =>
    api.get<LevelReportView>(`/api/level/report${toQuery({ history: params.history ? 1 : undefined, limit: params.limit })}`),
};
